import React, { useEffect, useState } from 'react';
import { Button, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import Loader from '../components/atoms/Loader';
import LoaderButton from '../components/LoaderButton';
import ParsDetail from '../components/ParsDetail';
import yyyymmdd from '../libs/date_convert';
import { ViewPars, LocationIDs } from '../libs/GraphQL';
import sortLocations from '../utils';

function ListItem({ currentLocation, currentDate, pars }) {
  if (!pars || pars.length === 0 || !currentDate) {
    return null;
  }
  return (
    <ParsDetail
      key={`${currentDate}#${currentLocation}`}
      pars={pars}
      date={currentDate.toString().substring(0, 15)}
      location={currentLocation.toString()}
    />
  );
}

const SingularLocationParsV2 = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pars, setPars] = useState([]);
  const [locations, setLocations] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [searchDate, setSearchDate] = useState(yyyymmdd(new Date()));
  const [currentLocation, setCurrentLocation] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    try {
      getLocations()
        // eslint-disable-next-line no-shadow
        .then((locations) => {
          setLocations(locations.data.locations.locations);
        })
        .then(() => {
          setShowDatePicker(true);
        });
    } catch (e) {
      console.error(e);
      history.push('/error');
    }
    setIsLoading(false);
  }, []);

  const getLocations = () => LocationIDs();

  const handleDateChangeV2 = (value) => {
    setCurrentDate(value);
    setSearchDate(yyyymmdd(value));
  };

  const getReportData = () => {
    if (currentLocation !== '') {
      loadPars(currentLocation, searchDate);
    }
  };

  const togglePicker = () => {
    setShowDatePicker(!showDatePicker);
  };

  const handleLocationSelect = (event) => {
    if (event.target.value !== 'do_not_pick') {
      setCurrentLocation(event.target.value);
    }
  };

  // eslint-disable-next-line no-shadow
  const loadPars = async (currentLocation, currentDate) => {
    setIsLoading(true);
    if (currentLocation === '' || currentDate === '') {
      return;
    }
    // is there a function that does this for me
    const date = `${currentDate.substring(0, 4)}-${currentDate.substring(
      4,
      6,
    )}-${currentDate.substring(6, 8)}`;
    try {
      setError(false);
      const res = await ViewPars(date, currentLocation);
      setShowDatePicker(false);
      setPars(res.data.jitLocations[0].pars);
    } catch (e) {
      setPars({});
      setError(true);
      alert(
        'There was an issue finding pars at that date/location combination',
      );
    }
    setIsLoading(false);
  };
  const displayLocations = () => {
    if (locations.length > 0) {
      const sortedLocations = sortLocations(locations);
      const locationList = sortedLocations.map((location) => {
        return (
          <option
            key={location.id}
            value={location.id}
            onSelect={(event) => {
              handleLocationSelect(event);
            }}
          >
            {location.id}
          </option>
        );
      });
      const locationsListComp = (
        <FormGroup
          onChange={handleLocationSelect}
          controlId="formControlsSelectMultiple"
        >
          <FormControl componentClass="select">
            <option value="do_not_pick">Choose Location</option>
            {locationList}
          </FormControl>
        </FormGroup>
      );
      return locationsListComp;
    }
  };

  return (
    <div className="Locations">
      {isLoading && <Loader />}
      {!showDatePicker && !isLoading && (
        <LoaderButton
          block
          bsStyle="primary"
          bsSize="large"
          onClick={togglePicker}
          type="submit"
          isLoading={isLoading}
          text="Choose Another Date or Location"
          loadingText="Loading data…"
        />
      )}
      {showDatePicker && !isLoading && (
        <Grid style={{ minHeight: '100vh' }}>
          <Row className="text-center">{locations && displayLocations()}</Row>
          <Row className="text-center" style={{ marginBottom: '15px' }}>
            <DatePicker onChange={handleDateChangeV2} value={currentDate} />
          </Row>
          <Row className="text-center">
            <Button bsStyle="primary" bsSize="large" onClick={getReportData}>
              {' '}
              Search{' '}
            </Button>
          </Row>
        </Grid>
      )}
      <hr />
      <p style={{ pageBreakBefore: 'always' }} />
      <p />
      {!error && !isLoading && (
        <ListItem
          pars={pars}
          currentDate={currentDate}
          currentLocation={currentLocation}
        />
      )}
    </div>
  );
};

export default SingularLocationParsV2;
